'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { RadioGroupItem } from '@achra/ui/radio-group';
import { useMemo } from 'react';
import type { ServiceTierFieldsFragment } from '@/modules/__generated__/graphql/switchboard-generated';
import { BILLING_CYCLE_LABELS } from '@/modules/service-purchase/lib/constants';
import { formatMetricLabel, formatPrice, getUnitPriceMetrics } from '@/modules/service-purchase/lib/utils';
import { usePricingCalculatorContext } from '@/modules/service-purchase/providers/pricing-calculator-provider';
interface PlanSelectorItemProps {
  tier: ServiceTierFieldsFragment;
  isSelected?: boolean;
}
function PlanSelectorItem(t0) {
  const $ = _c(27);
  const {
    tier,
    isSelected: t1
  } = t0;
  const isSelected = t1 === undefined ? false : t1;
  const inputId = tier.id;
  const {
    selectedBillingCycle,
    tierHeaderPrices
  } = usePricingCalculatorContext();
  const displayPrice = tierHeaderPrices[tier.id] ?? null;
  let t2;
  if ($[0] !== tier) {
    t2 = getUnitPriceMetrics(tier);
    $[0] = tier;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const unitPriceMetrics = t2;
  const t3 = isSelected ? "cursor-default" : "cursor-pointer";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("flex h-full w-full min-w-0 flex-col items-center justify-start px-0 sm:px-1", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== inputId || $[5] !== tier.id) {
    t5 = <RadioGroupItem value={tier.id} id={inputId} className="border-foreground [&_svg]:fill-foreground text-foreground" />;
    $[4] = inputId;
    $[5] = tier.id;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== tier.name) {
    t6 = <span className="text-foreground text-sm/5.5 font-semibold">{tier.name}</span>;
    $[7] = tier.name;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="flex flex-col items-center gap-2">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== tier.mostPopular) {
    t8 = tier.mostPopular && <span className="bg-primary text-primary-foreground inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-bold tracking-wide whitespace-nowrap uppercase lg:px-2.5 lg:tracking-widest">Most popular</span>;
    $[12] = tier.mostPopular;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== displayPrice || $[15] !== selectedBillingCycle || $[16] !== tier.id || $[17] !== tier.isCustomPricing || $[18] !== tier.pricing || $[19] !== unitPriceMetrics) {
    t9 = tier.isCustomPricing ? <div className="flex w-full flex-col items-center gap-0.5"><span className="text-foreground/50 text-xs/5.5 font-semibold">Custom</span>{unitPriceMetrics.map((metric, index) => <span key={`${tier.id}-metric-${index}`} className="text-primary dark:text-primary-foreground text-center text-xs/4.5 font-semibold">{metric.freeLimit ? <>{metric.freeLimit}{" "}<span className="text-foreground/50">{formatMetricLabel(metric.unitName ?? metric.metric)}/mo</span></> : <>~{formatPrice(Number(metric.unitPrice), tier.pricing.currency)}{" "}<span className="text-foreground/50">per {formatMetricLabel(metric.unitName ?? metric.metric)}</span></>}</span>)}<span className="text-foreground text-xs leading-4.5 font-normal">{BILLING_CYCLE_LABELS[selectedBillingCycle]}</span></div> : <div className="flex w-full flex-col items-center gap-0.5"><div>{displayPrice === null ? <span className="text-muted-foreground text-xs/5.5 font-semibold">—</span> : displayPrice === 0 ? <span className="text-primary dark:text-primary-foreground text-xs/5.5 font-semibold">Free</span> : <><span className="text-primary dark:text-primary-foreground text-xs/5.5 font-semibold">{formatPrice(displayPrice, tier.pricing.currency)}</span><span className="text-foreground/70 text-xs/5.5 font-semibold">/mo</span></>}</div>{unitPriceMetrics.map((metric_0, index_0) => <span key={`${tier.id}-metric-${index_0}`} className="text-primary dark:text-primary-foreground text-center text-xs/4.5 font-semibold">{metric_0.freeLimit ? <>{metric_0.freeLimit}{" "}<span className="text-foreground/50">{formatMetricLabel(metric_0.unitName ?? metric_0.metric)}/mo</span></> : <>~{formatPrice(Number(metric_0.unitPrice), tier.pricing.currency)}{" "}<span className="text-foreground/50">per {formatMetricLabel(metric_0.unitName ?? metric_0.metric)}</span></>}</span>)}<span className="text-foreground text-center text-xs leading-4.5 font-normal">{BILLING_CYCLE_LABELS[selectedBillingCycle]}</span></div>;
    $[14] = displayPrice;
    $[15] = selectedBillingCycle;
    $[16] = tier.id;
    $[17] = tier.isCustomPricing;
    $[18] = tier.pricing;
    $[19] = unitPriceMetrics;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== inputId || $[22] !== t4 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <label htmlFor={inputId} className={t4}>{t7}{t8}{t9}</label>;
    $[21] = inputId;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
export { PlanSelectorItem };